import { render, staticRenderFns } from "./componeyInfoCrad.vue?vue&type=template&id=067f67be&scoped=true&"
import script from "./componeyInfoCrad.vue?vue&type=script&lang=js&"
export * from "./componeyInfoCrad.vue?vue&type=script&lang=js&"
import style0 from "./componeyInfoCrad.vue?vue&type=style&index=0&id=067f67be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f67be",
  null
  
)

export default component.exports